<template>
  <div class="count">
    <programme></programme>
    <attribute></attribute>
    <sources></sources>
  </div>
</template>

<script>
import programme from '@/views/count/cent/programme'
import attribute from '@/views/count/cent/attribute'
import sources from '@/views/count/cent/source'
export default {
  components: {
    programme,
    attribute,
    sources
  },
  data() {
    return {


    }
  }
}
</script>
 
<style lang = "less" scoped>
.count {
  background-color: #f5f5f5;
  padding-top: .14rem;
  min-height: 100vh;
}
</style>